export default __webpack_public_path__ + "static/media/mesadetrabajo.10ca089f.jpg";